function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
export function isElement(el) {
    return typeof Element !== 'undefined' && _instanceof(el, Element);
}
export function getTextContents(node) {
    if (!node) {
        return '';
    }
    if (isElement(node)) {
        return node.textContent || '';
    }
    if (typeof node === 'string') {
        return node;
    }
    var textContent = node.children.reduce(function(acc, curr) {
        return typeof curr === 'string' ? acc + curr : acc;
    }, '');
    return textContent;
}
export function findFirstChildWithTagName(tagName, root) {
    return root.children.find(function(c) {
        if (typeof c !== 'string') {
            return c.tagName === tagName;
        }
    });
}

//# sourceMappingURL=dom.js.map